
import {
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Checkbox,
} from '@mui/material';
import './table.scss';
import { formatCost } from '../../../utils/format';
import PlanRevisedQtyTableCell from './PlanRevisedQtyTableCell';
import PlanRevisedPaxTableCell from './PlanRevisedPaxTableCell';
import { useSelector } from 'react-redux';

interface UpdateProductionPlanTableProps {
  updateProductionList:any;
  selectedSites: object[];
  setSelectedSites: React.Dispatch<React.SetStateAction<object[]>>;
  handleSaveUpdateProductionPlan: (savedetails: object) => void;
}


const UpdateProductionPlanTable: React.FC<UpdateProductionPlanTableProps> = ({ updateProductionList, selectedSites, setSelectedSites, handleSaveUpdateProductionPlan}): JSX.Element => {
  const { params } = useSelector((state: any) => state.updateProductionPlan);

  
  const handleSelectAllSites = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event?.target?.checked) {
      const selectedSitesData:object[] = updateProductionList?.map((site: any) => {
        return {
          sitecode: site?.sitecode,
          cafecode: site?.cafecode,
          cafename: site?.cafename,
        };
      });
      setSelectedSites(selectedSitesData);
    } else {
      setSelectedSites([]);
    }
  }

  const handleSelectSingleSite = (event: React.ChangeEvent<HTMLInputElement>, site: any) => {
    if (event?.target?.checked) {
      const selectedSiteData = {
        sitecode: site?.sitecode,
        cafecode: site?.cafecode,
        cafename: site?.cafename,
      }
      setSelectedSites((prev: object[]) => [selectedSiteData, ...prev]);
    } else {
      const removedSitesData = selectedSites?.filter((selectedSite: any) => selectedSite?.sitecode !== site?.sitecode || selectedSite?.cafecode !== site?.cafecode);
      setSelectedSites(removedSitesData);
    }
  }

  return (
    <div className="table-wrapper UpdateProductionPlanTable">
      <TableContainer component={Paper} className="table-inner" sx={{ maxHeight: 440 }}>
        <MuiTable stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>
                <Typography variant="h6" className="table-title">
                  <Checkbox checked={!!updateProductionList?.length && selectedSites?.length==updateProductionList?.length} onChange={(event)=>handleSelectAllSites(event)} />
                </Typography>
              </TableCell>
              <TableCell className="text-left">
                <Typography variant="h6" className="table-title">
                  Site Name
                </Typography>
              </TableCell>
              <TableCell className="text-left">
                <Typography variant="h6" className="table-title">
                  Cafe Name
                </Typography>
              </TableCell>
              <TableCell className="text-left">
                <Typography variant="h6" className="table-title">
                  Requested Dish
                </Typography>
              </TableCell>
              <TableCell className="text-left">
                <Typography variant="h6" className="table-title">
                  Revised Dish
                </Typography>
              </TableCell>           
              <TableCell>
                <Typography variant="h6" className="table-title">
                  Dish UOM
                </Typography>
              </TableCell>           
              <TableCell>
                <Typography variant="h6" className="table-title">
                  Theo Cost (Kg)
                </Typography>
              </TableCell>           
              <TableCell>
                <Typography variant="h6" className="table-title">
                  PAX 
                </Typography>
              </TableCell>           
              <TableCell>
                <Typography variant="h6" className="table-title">
                  Planned Qty
                </Typography>
              </TableCell>           
              <TableCell>
                <Typography variant="h6" className="table-title">
                  Revised PAX
                </Typography>
              </TableCell>           
              <TableCell>
                <Typography variant="h6" className="table-title">
                  Revised Qty
                </Typography>
              </TableCell>           
              <TableCell>
                <Typography variant="h6" className="table-title">
                  Total Theo Cost
                  of Requested Dish
                </Typography>
              </TableCell>           
              <TableCell>
                <Typography variant="h6" className="table-title">
                  Total Theo Cost
                  of Replaced Dish
                </Typography>
              </TableCell>           
              <TableCell>
                <Typography variant="h6" className="table-title">
                  Cost
                  Variance
                </Typography>
              </TableCell>           
            </TableRow>
          </TableHead>
          <TableBody>
            {!!updateProductionList?.length && (
              updateProductionList?.map((site: any) => {
                return (
                  <TableRow>
                    <TableCell>
                      <Checkbox checked={selectedSites?.some((selectedSite:any) => selectedSite.sitecode===site.sitecode && selectedSite.cafecode===site.cafecode)} onChange={(event)=>handleSelectSingleSite(event,site)}/>
                    </TableCell>
                    <TableCell className="text-left">{site?.sitename}</TableCell>
                    <TableCell className="text-left">{site?.cafename}</TableCell>
                    <TableCell className="text-left">{site?.requestdishname}</TableCell>
                    <TableCell className="text-left">{site?.reviseddishname}</TableCell>
                    <TableCell>{site?.uom}</TableCell>
                    <TableCell>₹ {formatCost(site?.theocost,2)}</TableCell>
                    <TableCell>{site?.pax}</TableCell>
                    <TableCell>{formatCost(site?.planquantity,3)}</TableCell>
                    <TableCell>
                    <PlanRevisedPaxTableCell site={site} handleSavePax={handleSaveUpdateProductionPlan}  disabled= {params?.isdisable} />
                    </TableCell>
                    <TableCell>
                      <PlanRevisedQtyTableCell site={site} handleSaveQty={handleSaveUpdateProductionPlan}  disabled= {params?.isdisable} />
                    </TableCell>
                    <TableCell>₹ {formatCost(site?.requesttotaltheocost,2)}</TableCell>
                    <TableCell>₹ {formatCost(site?.replacedtotaltheocost,2)}</TableCell>
                    <TableCell>{(((site?.replacedtotaltheocost - site?.requesttotaltheocost) / site?.requesttotaltheocost) * 100)?.toFixed()} %</TableCell>
                  </TableRow>
                );
              })
            )}
            {!updateProductionList?.length && <TableRow>
                <TableCell colSpan={14}>No site and cafes found</TableCell>
              </TableRow>}
          </TableBody>
        </MuiTable>
      </TableContainer>
    </div>
  );
};

export default UpdateProductionPlanTable;
